import { useMutation, useQuery } from "@tanstack/react-query";
import { client } from "./client";

export const useGetAllUsers = () => {
    const token = localStorage.getItem("accessToken");
    return useQuery({
        queryKey: ["allUsers"],
        queryFn: async () => {
            const response = await client("auth/usersforAdmin", {
                method: "GET",
                headers: {
                    Authorization: token ? `Bearer ${token}` : undefined,
                },
            });
            return response;
        },
    });
};


export const useSetUserReferralLimit = () => {
    const token = localStorage.getItem("accessToken");
    return useMutation({
        mutationFn: async ({ id, limit }) => {
            const response = await client(`auth/user/${id}/set-referral-limit`, {
                method: "PATCH",
                data: limit,
                headers: {
                    Authorization: token ? `Bearer ${token}` : undefined,
                },
            });
            return response;
        },
    });
};


export const useSetRewardPerReferral = () => {
    const token = localStorage.getItem("accessToken");
    return useMutation({
        mutationFn: async (rewardPerReferral) => {
            const response = await client(`settings/reward`, {
                method: "PATCH",
                data: rewardPerReferral ,
                headers: {
                    Authorization: token ? `Bearer ${token}` : undefined,
                },
            });
            return response;
        },
    });
};